import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ROUTE_CONSTANTS } from "./routes/routeConstant";
import { Loader } from "./components/layout";
import AuthenticatedRoute from "./routes/AuthenticatedRoute";
import TokenHandler from "./routes/TokenHandler";
import DashboardLayout from "./layout/DashboardLayout";
import { publicRoutes, privateRoutes } from "./routes/routeConfig";
import NotFound from "src/container/NotFound";
import { useLoginContext } from "src/contextApi/LoginContext";
import PrivacyPolicyPage from "src/container/PrivacyPolicyPage/PrivacyPolicyPage";

const AppRoutes: React.FC = () => {
  const { isAuthenticated } = useLoginContext();

  const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    if (isAuthenticated) {
      return <Navigate to={ROUTE_CONSTANTS.HOME} replace />;
    }
    return <>{children}</>;
  };

  return (
    <Routes>
      {publicRoutes.map(({ path, element }) => (
        <Route key={path} path={path} element={<PublicRoute>{element}</PublicRoute>} />
      ))}

      {privateRoutes.map(({ path, element }) => (
        <Route
          key={path}
          path={path}
          element={
            <AuthenticatedRoute>
              <DashboardLayout>{element}</DashboardLayout>
            </AuthenticatedRoute>
          }
        />
      ))}

      <Route
        path={ROUTE_CONSTANTS.PRIVACY_POLICY}
        element={
          <AuthenticatedRoute>
            <PrivacyPolicyPage />
          </AuthenticatedRoute>
        }
      />

      <Route
        path={ROUTE_CONSTANTS.TOKEN}
        element={
          <TokenHandler>
            <></>
          </TokenHandler>
        }
      />
      <Route path={ROUTE_CONSTANTS.NOT_FOUND} element={<NotFound />} />
    </Routes>
  );
};

function App() {
  return (
    <React.Suspense fallback={<Loader height="h-screen" size="large" />}>
      <AppRoutes />
    </React.Suspense>
  );
}

export default App;
